export { MenuProvider, useMenuContext_unstable } from './contexts/menuContext';
export type { MenuContextValue } from './contexts/menuContext';
export { MenuTriggerContextProvider, useMenuTriggerContext_unstable } from './contexts/menuTriggerContext';
export { MenuGroupContextProvider, useMenuGroupContext_unstable } from './contexts/menuGroupContext';
export type { MenuGroupContextValue } from './contexts/menuGroupContext';
export { MenuListProvider, useMenuListContext_unstable } from './contexts/menuListContext';
export type { MenuListContextValue } from './contexts/menuListContext';

export { Menu, renderMenu_unstable, useMenuContextValues_unstable, useMenu_unstable } from './Menu';
export type {
  MenuContextValues,
  MenuOpenChangeData,
  MenuOpenEvent,
  // MenuOpenEvents is deprecated but removing it would be a breaking change
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  MenuOpenEvents,
  MenuProps,
  MenuSlots,
  MenuState,
} from './Menu';
export {
  MenuDivider,
  menuDividerClassNames,
  renderMenuDivider_unstable,
  useMenuDividerStyles_unstable,
  useMenuDivider_unstable,
} from './MenuDivider';
export type { MenuDividerProps, MenuDividerSlots, MenuDividerState } from './MenuDivider';
export {
  MenuGroup,
  menuGroupClassNames,
  renderMenuGroup_unstable,
  useMenuGroupContextValues_unstable,
  useMenuGroupStyles_unstable,
  useMenuGroup_unstable,
} from './MenuGroup';
export type { MenuGroupContextValues, MenuGroupProps, MenuGroupSlots, MenuGroupState } from './MenuGroup';
export {
  MenuGroupHeader,
  menuGroupHeaderClassNames,
  renderMenuGroupHeader_unstable,
  useMenuGroupHeaderStyles_unstable,
  useMenuGroupHeader_unstable,
} from './MenuGroupHeader';
export type { MenuGroupHeaderProps, MenuGroupHeaderSlots, MenuGroupHeaderState } from './MenuGroupHeader';
export {
  MenuItem,
  menuItemClassNames,
  renderMenuItem_unstable,
  useMenuItemStyles_unstable,
  useMenuItem_unstable,
} from './MenuItem';
export type { MenuItemProps, MenuItemSlots, MenuItemState } from './MenuItem';
export {
  MenuItemCheckbox,
  menuItemCheckboxClassNames,
  renderMenuItemCheckbox_unstable,
  useMenuItemCheckboxStyles_unstable,
  useMenuItemCheckbox_unstable,
} from './MenuItemCheckbox';
export type { MenuItemCheckboxProps, MenuItemCheckboxState } from './MenuItemCheckbox';
export {
  MenuItemRadio,
  menuItemRadioClassNames,
  renderMenuItemRadio_unstable,
  useMenuItemRadioStyles_unstable,
  useMenuItemRadio_unstable,
} from './MenuItemRadio';
export type { MenuItemRadioProps, MenuItemRadioState } from './MenuItemRadio';
export {
  MenuList,
  menuListClassNames,
  renderMenuList_unstable,
  useMenuListContextValues_unstable,
  useMenuListStyles_unstable,
  useMenuList_unstable,
} from './MenuList';
export type {
  MenuCheckedValueChangeData,
  MenuCheckedValueChangeEvent,
  MenuListContextValues,
  MenuListProps,
  MenuListSlots,
  MenuListState,
  // UninitializedMenuListState is deprecated but removing it would be a breaking change
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  UninitializedMenuListState,
} from './MenuList';
export {
  MenuPopover,
  menuPopoverClassNames,
  renderMenuPopover_unstable,
  useMenuPopoverStyles_unstable,
  useMenuPopover_unstable,
} from './MenuPopover';
export type { MenuPopoverProps, MenuPopoverSlots, MenuPopoverState } from './MenuPopover';
export {
  MenuSplitGroup,
  menuSplitGroupClassNames,
  renderMenuSplitGroup_unstable,
  useMenuSplitGroupStyles_unstable,
  useMenuSplitGroup_unstable,
} from './MenuSplitGroup';
export type { MenuSplitGroupProps, MenuSplitGroupSlots, MenuSplitGroupState } from './MenuSplitGroup';
export { MenuTrigger, renderMenuTrigger_unstable, useMenuTrigger_unstable } from './MenuTrigger';
export type { MenuTriggerChildProps, MenuTriggerProps, MenuTriggerState } from './MenuTrigger';

export { useCheckmarkStyles_unstable } from './selectable/index';
export type { MenuItemSelectableProps, MenuItemSelectableState, SelectableHandler } from './selectable/index';

export {
  MenuItemLink,
  menuItemLinkClassNames,
  renderMenuItemLink_unstable,
  useMenuItemLinkStyles_unstable,
  useMenuItemLink_unstable,
} from './MenuItemLink';
export type { MenuItemLinkProps, MenuItemLinkSlots, MenuItemLinkState } from './MenuItemLink';

export { MENU_ENTER_EVENT, dispatchMenuEnterEvent, useOnMenuMouseEnter } from './utils';
export {
  MenuItemSwitch,
  useMenuItemSwitch_unstable,
  useMenuItemSwitchStyles_unstable,
  renderMenuItemSwitch_unstable,
  menuItemSwitchClassNames,
} from './MenuItemSwitch';

export type { MenuItemSwitchProps, MenuItemSwitchState, MenuItemSwitchSlots } from './MenuItemSwitch';

// Experimental: Base hooks - will be enabled in the experimental release branch
// export { useMenuItemBase_unstable } from './MenuItem';
// export { useMenuItemCheckboxBase_unstable } from './MenuItemCheckbox';
// export { useMenuItemRadioBase_unstable } from './MenuItemRadio';
// export { useMenuItemSwitchBase_unstable } from './MenuItemSwitch';
